import { render } from "./ViewsColumn.vue?vue&type=template&id=7b6f4162&ts=true&lang=pug"
import script from "./ViewsColumn.vue?vue&type=script&lang=ts"
export * from "./ViewsColumn.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__